import React from "react";
/**
 * Render a table row representing a week in the calendar.
 *
 * @group Components
 * @see https://daypicker.dev/guides/custom-components
 */
export function Week(props) {
    const { week, ...trProps } = props;
    return React.createElement("tr", { ...trProps });
}
//# sourceMappingURL=Week.js.map